import type { TColorVariant } from '@klv/shared/styles/types';
import styled from 'styled-components';
import Grid from '@klv/utils/grid';
import Typography from '@klv/atoms/typography';

export const StyledTileList = styled.div<{ $backgroundColor: TColorVariant; }>`
  background-color: ${({ $backgroundColor, theme }) => theme.tileList[$backgroundColor].backgroundColor};
  ${({ theme }) => `${theme.globalPadding}`};
`;

export const StyledGrid = styled(Grid)`
  gap: 2.4rem;
`;

export const HeadlineContainer = styled.div`
  grid-column: 1 / -1;
  text-align: center;
  margin-bottom: 4.8rem;
`;

export const StyledHeadline = styled(Typography)`
  margin: 0 auto .8rem auto;
  max-width: 73%;
  word-wrap: break-word;
  ${({ theme }) => `
    ${theme.screenSize.s576.mediaQuery} {
      max-width: 65%;
    }
    ${theme.screenSize.s768.mediaQuery} {
      max-width: 48%
    }
    ${theme.screenSize.s1024.mediaQuery} {
      max-width: 67%
    }
    ${theme.screenSize.s1200.mediaQuery} {
      max-width: 49%;
    }
  `}
`;

export const StyledSubheadline = styled(Typography)`
  max-width: 100%;
  margin: 0 auto;
  word-wrap: break-word;
  ${({ theme }) => `
    ${theme.screenSize.s576.mediaQuery} {
      max-width: 83%;
    }
    ${theme.screenSize.s768.mediaQuery} {
      max-width: 64%
    }
    ${theme.screenSize.s1024.mediaQuery} {
      max-width: 100%
    }
    ${theme.screenSize.s1200.mediaQuery} {
      max-width: 66%;
    }    
  `}
`;

export const ButtonContainer = styled.div`
  display: block;
  grid-column: 1 / -1;
  margin-top: 4.45rem;
  text-align: center;
`;
